(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["milovie-collage"] && !Shopify.designMode) return;
  try {
    (function () {
    class MilovieCollage {
      constructor(root) {
        this.root = root;
        this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-mc-card]'));
        this.n = this.cards.length;
        this.main = this.n > 1 ? 1 : 0;
        this.interval = parseInt(root.dataset.interval, 10) || 4000;
        this.auto = root.dataset.autorotate === 'true';
        this.pauseHover = root.dataset.pauseHover === 'true';
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.timer = null;

        this.render();

        if (this.pauseHover) {
          root.addEventListener('mouseenter', () => this.stop());
          root.addEventListener('mouseleave', () => { if (this.auto && !this.reduce) this.start(); });
        }
        if (this.auto && !this.reduce && this.n > 1) this.start();
      }

      role(i) {
        const d = (i - this.main + this.n) % this.n;   // Vorwaerts-Distanz zur Mitte
        if (d === 0) return 'is-main';
        if (d === 1) return 'is-right';
        if (d === this.n - 1) return 'is-left';
        return d <= this.n / 2 ? 'is-hidden from-right' : 'is-hidden to-left';
      }

      render() {
        this.cards.forEach((card, i) => {
          card.className = 'mc-card ' + this.role(i);
          const v = card.querySelector('video');
          if (!v) return;
          if (card.classList.contains('is-hidden')) {
            v.pause();
          } else {
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          }
        });
      }

      next() { this.main = (this.main + 1) % this.n; this.render(); }
      goTo(i) { this.main = ((i % this.n) + this.n) % this.n; this.render(); }

      start() {
        this.stop();
        if (this.n > 1) this.timer = setInterval(() => this.next(), this.interval);
      }
      stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    }

    function initAll(scope) {
      const ctx = scope && scope.querySelectorAll ? scope : document;
      ctx.querySelectorAll('.milovie-collage[data-mc]').forEach((el) => {
        if (el.__mc) return;
        el.__mc = new MilovieCollage(el);
      });
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    initAll();

    /* Theme-Editor */
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
    document.addEventListener('shopify:section:unload', (e) => {
      e.target.querySelectorAll('.milovie-collage[data-mc]').forEach((el) => {
        if (el.__mc) { el.__mc.stop(); el.__mc = null; }
      });
    });
    document.addEventListener('shopify:block:select', (e) => {
      const root = e.target.closest && e.target.closest('.milovie-collage');
      if (!root || !root.__mc) return;
      const card = e.target.closest('[data-mc-card]') || e.target.querySelector('[data-mc-card]');
      const idx = root.__mc.cards.indexOf(card);
      root.__mc.stop();
      if (idx > -1) root.__mc.goTo(idx);
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      const root = e.target.closest && e.target.closest('.milovie-collage');
      if (root && root.__mc && root.__mc.auto && !root.__mc.reduce) root.__mc.start();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
